import apiConfig, {
  ERROR_TIMEOUT,
  ADD_SUCCESS_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  INVALID_SESSION,
} from "../../App.config";
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import * as toastAction from "../actions/toastAction";
import history from "../../utilities/history";
import { isSessionValid } from "./profileAction";
import { setCaseStatusDetails } from "./attachmentsAction";

/************************************ ACTIONS ****************************************/

function setEmployeebyManagerAction(applicants) {
  return {
    type: types.SET_EMPLOYEE_BY_MANAGER,
    applicants,
  };
}

function setCaseStatusAction(caseStatus) {
  return {
    type: types.SET_CASE_STATUS,
    caseStatus,
  };
}

function setCaseStatusModifiedAction(caseStatusModified) {
  return {
    type: types.SET_CASE_STATUS_MODIFIED,
    caseStatusModified,
  };
}

function setCaseStatusByEINAction(caseStatusDetails) {
  return {
    type: types.SET_ERS_CASE_DETAIL_BY_EIN,
    caseStatusDetails,
  };
}

function setFilteredEmployeebyManagerAction(filteredApplicants) {
  return {
    type: types.SET_FILTERED_EMPLOYEE_BY_MANAGER,
    filteredApplicants,
  };
}

function setTotalRowsAction(totalRows) {
  return {
    type: types.SET_ERS_TOTAL_ROWS,
    totalRows,
  };
}

function setCurretPageAction(currentPage) {
  return {
    type: types.SET_ERS_CURRENT_PAGE,
    currentPage,
  };
}

function setPageSizeAction(pageSize) {
  return {
    type: types.SET_ERS_PAGE_SIZE,
    pageSize,
  };
}
/// Case Status pagination action
function setCaseStatusTotalRowsAction(caseStatusTotalRows) {
  return {
    type: types.SET_CASESTATUS_TOTAL_ROWS,
    caseStatusTotalRows,
  };
}

function setCaseStatusCurretPageAction(caseStatusCurrentPage) {
  return {
    type: types.SET_CASESTATUS_CURRENT_PAGE,
    caseStatusCurrentPage,
  };
}

function setCaseStatusPageSizeAction(caseStatusPageSize) {
  return {
    type: types.SET_CASESTATUS_PAGE_SIZE,
    caseStatusPageSize,
  };
}

function setActiveCasesByCaseId(selectedCaseDetail) {
  return {
    type: types.SET_SELECTED_CASE_DETAIL,
    selectedCaseDetail
  };
}

function setIsSelectedCase(isSelectedCase){
  return {
    type: types.SET_IS_SELECTED_CASE,
    isSelectedCase
  };
}

/************************************ ACTION CREATORS ****************************************/

export const setFilteredApplicants = (filteredApplicants) => (dispatch) => {
  dispatch(setFilteredEmployeebyManagerAction(filteredApplicants));
};

export const setCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCurretPageAction(currentPage));
};

export const setPageSize = (pageSize) => (dispatch) => {
  dispatch(setPageSizeAction(pageSize));
};

export const setCaseStatusCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCaseStatusCurretPageAction(currentPage));
};

export const setCaseStatusPageSize = (pageSize) => (dispatch) => {
  dispatch(setCaseStatusPageSizeAction(pageSize));
};

export const getEmployeebyManager = (pagination, searchKey, profileReducer) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getEmployeebyManager(pagination, searchKey, profileReducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setEmployeebyManagerAction([]));
        dispatch(setEmployeebyManagerAction(data.employeeList));
        dispatch(setTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getCaseStatus = (searchKey, pagination) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCaseStatus(searchKey, pagination)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setCaseStatusAction(data.employeeList));
        // dispatch(setTotalRowsAction(data.pagination.totalRows));
        dispatch(setCaseStatusAction(data.caseStatusDetails));
        dispatch(setCaseStatusModifiedAction(data.caseStatusDetails));
        dispatch(setCaseStatusTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getCaseStatusModalDetail = (ein) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCaseStatus()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setCaseStatusAction(data.employeeList));
        // dispatch(setTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          if (
            Array.isArray(data.caseStatusDetails) &&
            data.caseStatusDetails.length
          ) {
            let filteredCase = data.caseStatusDetails.find(
              (caseStatus) => caseStatus.ein === ein
            );
            dispatch(
              setCaseStatusByEINAction(
                filteredCase ? [{ ...filteredCase }] : null
              )
            );
          }
          // dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          // setTimeout(() => {
          //   dispatch(toastAction.showErrorMessage(false, ""));
          // }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const setCaseStatusModified = (modifiedCaseStatus) => (dispatch) => {
  dispatch(setCaseStatusModifiedAction(modifiedCaseStatus));
};

export const getAllActiveCasesByCaseId = (profileReducer, caseDetail) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAllActiveCasesByCaseId(profileReducer, caseDetail)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setActiveCasesByCaseId([]));
        dispatch(setActiveCasesByCaseId(data.caseStatusDetails));
        dispatch(setIsSelectedCase(true));
        // dispatch(setCaseStatusAction(data.employeeList));
        // dispatch(setTotalRowsAction(data.pagination.totalRows));
        // dispatch(setCaseStatusAction(data.caseStatusDetails));
        // dispatch(setCaseStatusModifiedAction(data.caseStatusDetails));
        // dispatch(setCaseStatusTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};
export const resetIsSelectedCase = (isSelectedCase) => (dispatch) => {
  dispatch(setIsSelectedCase(isSelectedCase));
};
